
<template>
  <div>
   <div class="loading">
     
    <div class="loader ">
        <div class="loader__filmstrip">
        </div>

    </div>
</div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  created() {

  },
  data() {
    return {
    }
  },
  props: {
   
  },
  methods: {
   
  },
}
</script>

<style lang="scss" scoped>

</style>

